module.exports = __webpack_public_path__ + "static/media/lp2.6c37bc78.jpg";